import { LazyLoad } from 'app/utils';

export const UserDetailPage = LazyLoad(
  () => import('./index'),
  (module) => module.UserDetailPage,
);
